// Single source of truth for broadcast enums (send-via / status). Every
// other module — server services, server route schemas, web queries, web
// components — imports from here. Const arrays drive both the TypeScript
// union types AND the Zod schemas, so a new enum member can be added in
// exactly one place.
//
// The legacy `audience` enum was dropped in the Phase 3 audience-spec
// migration (server migration 0070). Audience targeting is fully driven
// by the structured `AudienceSpec` shape — see
// `apps/server/src/groups/service/audience-spec.ts`.
//
// sendVia values:
//   - 'email' — SES only (platform admin broadcasts use this; no in-app
//     notification fires, the email lands in the recipient's inbox).
//   - 'email_in_app' — SES email + in-app notification feed entry
//     (group-leader broadcasts use this; the in-app row reads
//     "From {groupName}: {subject}").
// The DB CHECK on `admin_broadcasts.send_via` still allows the legacy
// values `in_app` and `email_in_app_push`. They were never wired:
// `in_app` would still queue SES emails (dispatch-broadcast doesn't gate
// on send_via), and no push pipeline exists. Removing them from the
// CHECK requires a follow-up migration; tightening the Zod boundary
// here closes the API-level surface immediately.
import { z } from 'zod';
export const BROADCAST_SEND_VIAS = [
    'email',
    'email_in_app',
];
export const BroadcastSendViaSchema = z.enum(BROADCAST_SEND_VIAS);
export const BROADCAST_STATUSES = ['draft', 'scheduled', 'sent'];
export const BroadcastStatusSchema = z.enum(BROADCAST_STATUSES);
//# sourceMappingURL=broadcast-enums.js.map